export default __webpack_public_path__ + "static/familaVisual-f44341210ec5c00e07defc6cfa4d7e23.jpg";